export enum QuoteValueType {
  Currency,
  Percent,
  Date,
}
